module.exports = __webpack_public_path__ + "static/happy-horizon@2x-1da3fa8e6c63af511b146bb89922cfda.png";